import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastifyService  = {
    success: (message:any) => {
        toast.success(message);
    },

    error: (message:any) => {
        toast.error(message);
    },

    warning: (message:any) => {
        toast.warning(message);
    },
    
    info: (message:any) => {
        toast.info(message);
    }
}

export default ToastifyService ;